import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Back from "../main/back";
import AppContext from "../appContext";
import RedirectPromo from "./redirecionamento-pedidos";
import { Tabs, Tab, Box, Container } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Input from "../components/inputs/input";
import { consultarVoucher } from "../Functions/voucher/consultar-voucher";
import Swal from "sweetalert2";
import { styles } from "./gerar-cupons.styles";
import "./index.css";

class GerarCupons extends Component {
  constructor() {
    super();
    this.iframeRef = React.createRef();
    GerarCupons.contextType = AppContext;

    this.state = {
      labData: null,
      redirect: false,
      redirectL:false,
      activeTab: 0,
      codigoCupom: '',
      showRedirect: false,
      iframeLoading: true,
      utlizarCupom: false
    };
    let role = false;
    role = GerarCupons.contextType._currentValue.userSession.modulos.find(element => element === "Gerar Cupons");
      if (!role) {
        this.state = { redirectL: true };
      }
  }

  componentDidMount() {
    window.addEventListener("message", this.handleMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage, false);
  }

  handleMessage = async event => {
    //if (event.origin !== "") {
   //   return;
   // }

    const { data } = event;

    if (data.event === "CONCLUIR") {
      const { cnpj_lab, cnpj_otica, numero_cupom, total_pares, qtd_pares, quantidade_pares } = data.data;

      const camposPares = Object.keys(data.data).filter(k =>
        k.toLowerCase().includes('par') ||
        k.toLowerCase().includes('quantidade') ||
        k.toLowerCase().includes('total') ||
        k.toLowerCase().includes('qtd')
      );

      const totalParesIframe = total_pares || qtd_pares || quantidade_pares || data.data.pares?.length;

      this.context.showLoading();

      const dadosVoucher = await consultarVoucher(numero_cupom);

      this.context.hideLoading();

      this.setState({
        labData: {
          cnpj_lab: cnpj_lab,
          cnpj_otica: cnpj_otica,
          numero_cupom: numero_cupom,
          total_pares: totalParesIframe,
          identificacao_laboratorio: dadosVoucher.success ? (dadosVoucher.identificacao?.laboratorio || null) : null,
          utlizarCupom: false
        },
        redirect: true,
      });
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({
      activeTab: newValue,
      iframeLoading: newValue === 0 ? true : this.state.iframeLoading
    });
  }

  handleCodigoChange = (e) => {
    this.setState({ codigoCupom: e.target.value });
  }

  handleIframeLoad = () => {
    this.setState({ iframeLoading: false });
  }

  handleInformarCupom = async () => {
    const codigoCupomTrimmed = this.state.codigoCupom.trim();
    if (codigoCupomTrimmed) {
      this.context.showLoading();

      const dadosVoucher = await consultarVoucher(codigoCupomTrimmed, this.context.userSession);

      this.context.hideLoading();

      if (dadosVoucher.success) {

        this.setState({
          labData: {
            cnpj_lab: dadosVoucher.cnpjLab,
            cnpj_otica: dadosVoucher.cnpjOtica,
            numero_cupom: codigoCupomTrimmed,
            total_pares: dadosVoucher.paresQtd || 1,
            identificacao_laboratorio: dadosVoucher.identificacao?.laboratorio || null,
            utlizarCupom: true
          },
          redirect: true
        });
      } else {
        Swal.fire({
          title: "Aviso",
          html: dadosVoucher.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok"
        });
      }
    }
  }

  render() {
    const { classes } = this.props;

        if (this.state.redirectL) {
          return <Redirect to="/home" />;
        }

    return (
      <main className="gerar-cupons__main">
        <Back items={[{ label: 'Gerar Cupons' }]} title="Gerar Cupons" />
        <Container maxWidth="lg" disableGutters>
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              className={classes.tabs}
              TabIndicatorProps={{
                className: classes.indicator
              }}
            >
              <Tab
                id="tab-gerar-cupom"
                label="Gerar Cupom"
                className={this.state.activeTab === 0 ? classes.activeTab : classes.tab}
              />
              <Tab
                id="tab-utilizar-cupom"
                label="Utilizar Cupom"
                className={this.state.activeTab === 1 ? classes.activeTab : classes.tab}
              />
            </Tabs>

            {this.state.activeTab === 0 && (
              <div className="iframe_div">
                {!process.env.REACT_APP_ESSILOR_PROMO ? (
                  <div style={{
                    padding: "20px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffeaa7",
                    borderRadius: "4px",
                    margin: "20px"
                  }}>
                    <h3>⚠️ Configuração Necessária</h3>
                    <p><strong>A URL do iPremios não está configurada.</strong></p>
                    <p>Para resolver:</p>
                    <ol>
                      <li>Adicione no arquivo <code>.env</code> local:</li>
                      <pre style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        border: "1px solid #dee2e6"
                      }}>
                        REACT_APP_ESSILOR_PROMO=https://url-do-ipremios/
                      </pre>
                      <li>Reinicie o servidor de desenvolvimento</li>
                      <li>Faça logout e login novamente</li>
                    </ol>
                    <p style={{ marginTop: "15px", fontSize: "0.9em", color: "#666" }}>
                      <strong>Nota:</strong> Entre em contato com a equipe de desenvolvimento para obter a URL correta do ambiente iPremios.
                    </p>
                  </div>
                ) : (
                  <>
                    {this.state.iframeLoading && (
                      <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        paddingTop: "150px",
                        height: "700px"
                      }}>
                        <div style={{ textAlign: "center" }}>
                          <div className="loader" style={{
                            border: "4px solid #f3f3f3",
                            borderTop: "4px solid #3498db",
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            animation: "spin 2s linear infinite",
                            margin: "0 auto 20px"
                          }}></div>
                          <p style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#666",
                            margin: "0",
                            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
                          }}>Carregando...</p>
                        </div>
                      </div>
                    )}
                    <iframe
                      id="iframe"
                      ref={this.iframeRef}
                      src={process.env.REACT_APP_ESSILOR_PROMO + `2020/portal/createCoupon.zul?token=${sessionStorage.getItem("grant_token")}`}
                      width="100%"
                      height="700px"
                      onLoad={this.handleIframeLoad}
                      style={{ display: this.state.iframeLoading ? 'none' : 'block' }}
                    />
                  </>
                )}
              </div>
            )}

            {this.state.activeTab === 1 && (
              <Box className={classes.utilizarCupomContainer}>
                <div className="x-web-ordering-pedido__dados--card">
                  <Input
                    type="text"
                    name="codigo_cupom"
                    label="Código do Cupom Promocional"
                    width="400px"
                    aria="Código do cupom promocional"
                    placeholder="Digite o código do cupom"
                    value={this.state.codigoCupom}
                    onChange={this.handleCodigoChange}
                    autocomplete="off"
                  />
                </div>
                <button
                  id="btn-aplicar-cupom"
                  onClick={this.handleInformarCupom}
                  disabled={!this.state.codigoCupom.trim()}
                  className={classes.aplicarButton}
                >
                  Aplicar
                </button>
              </Box>
            )}
          </Box>
        </Container>
        {this.state.redirect && <RedirectPromo cnpj_lab={this.state.labData.cnpj_lab} cnpj_otica={this.state.labData.cnpj_otica} numero_cupom={this.state.labData.numero_cupom} total_pares={this.state.labData.total_pares} utilizar_cupom={this.state.labData.utlizarCupom} identificacao_laboratorio={this.state.labData.identificacao_laboratorio} />}
      </main>
    );
  }
}

export default withStyles(styles)(GerarCupons);
